import { __read } from "tslib";
import { applyPerformance, applyMutationObserver, applyPerformanceObserver, getDefaultBrowser, getDefaultPerformance, getDefaultDocument, getDefaultMutationObserver, getDefaultPerformanceObserver, onPageUnload, } from '../../utils';
import { getRequestIdleCallback, screenshot, measure, MAX_RELATED_TIME, blankErrorCompare, MAX_RENDER_TIME, DEFAULT_CHECK_TIME, MAX_CHECK_TIME, } from './util';
export var BlankScreenMonitor = function (win, document, performanceObserver, mutationObserver, performance) {
    if (win === void 0) { win = getDefaultBrowser(); }
    if (document === void 0) { document = getDefaultDocument(); }
    if (performanceObserver === void 0) { performanceObserver = getDefaultPerformanceObserver(); }
    if (mutationObserver === void 0) { mutationObserver = getDefaultMutationObserver(); }
    if (performance === void 0) { performance = getDefaultPerformance(); }
    if (!document || !win) {
        return;
    }
    return function (_b, cb) {
        var _c;
        var threshold = _b.threshold, takeScreenshot = _b.screenshot, rootSelector = _b.rootSelector, autoDetect = _b.autoDetect, ssUrl = _b.ssUrl;
        var requestIdleCallback = getRequestIdleCallback(win);
        var _d = __read(applyPerformance(performance), 2), now = _d[1];
        var blankInfo;
        var errorInfo;
        var otherReportedTimestamp = 0;
        var reported = false;
        var timer;
        var pureReport = function (base64) {
            blankInfo &&
                cb &&
                cb({
                    ev_type: 'blank_screen',
                    payload: {
                        timestamp: blankInfo[0],
                        score: blankInfo[1],
                        screenshot: base64,
                        error: errorInfo,
                    },
                });
        };
        var report = function () {
            if (!blankInfo || reported) {
                return;
            }
            reported = true;
            tearDown();
            takeScreenshot ? screenshot(pureReport, ssUrl, win, document) : pureReport();
        };
        var applyOtherReport = function (ev) {
            if (reported)
                return;
            otherReportedTimestamp = Date.now();
            if (errorInfo && otherReportedTimestamp - errorInfo.timestamp > MAX_RELATED_TIME) {
                errorInfo = undefined;
            }
            errorInfo = blankErrorCompare(errorInfo, ev);
        };
        var applyCheck = function (cb) {
            var checkTimer;
            var checkTimestamp;
            return function () {
                if (checkTimer) {
                    return;
                }
                checkTimestamp = Date.now();
                checkTimer = win.setTimeout(function () {
                    checkTimer = 0;
                    if (otherReportedTimestamp > checkTimestamp) {
                        return;
                    }
                    cb();
                }, now() > MAX_RENDER_TIME ? DEFAULT_CHECK_TIME : MAX_CHECK_TIME);
            };
        };
        var checkAndReport = applyCheck(report);
        onPageUnload(function () {
            !reported && pureReport();
        });
        var schedule = function () {
            timer && clearTimeout(timer);
            timer = win.setTimeout(function () {
                requestIdleCallback(function () {
                    win.requestAnimationFrame(function () {
                        var element = rootSelector ? document.querySelector(rootSelector) : document.body;
                        if (!element) {
                            return;
                        }
                        var score = measure(element, 0, 0, threshold);
                        if (score < threshold) {
                            blankInfo = [Date.now(), score];
                            checkAndReport();
                        }
                        else {
                            blankInfo = undefined;
                        }
                    });
                });
            }, 1000);
        };
        var tearDown = function () {
            clearTimeout(timer);
            mutDisconnect && mutDisconnect();
            perfDisconnect && perfDisconnect();
        };
        var _e = __read(applyMutationObserver(mutationObserver, schedule), 2), mutObserve = _e[0], mutDisconnect = _e[1];
        var _f = __read(applyPerformanceObserver(performanceObserver, function (_a, _i, arr) { return timer && arr.length > 1 && schedule(); }), 2), perfObserve = _f[0], perfDisconnect = _f[1];
        if (autoDetect) {
            mutObserve((_c = getDefaultDocument()) === null || _c === void 0 ? void 0 : _c.body, { subtree: true, childList: true });
            perfObserve('longtask', 'resource');
            schedule();
        }
        return [tearDown, applyOtherReport, schedule];
    };
};
//# sourceMappingURL=index.js.map